import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./Loading.module.scss";
export const Loading = ({ dataTestId, className, whiteDots }) => {
    const classes = classNames(styles.loading, styles.active, className);
    const dotClasses = classNames(styles.dot, { [styles.whiteDots]: whiteDots });
    return (_jsxs("ul", { "data-testid": dataTestId, className: classes, children: [_jsx("li", { className: dotClasses }), _jsx("li", { className: dotClasses }), _jsx("li", { className: dotClasses })] }));
};
//# sourceMappingURL=Loading.js.map